import { Injectable, effect, signal } from '@angular/core';

const STORAGE_KEY = 'silabvet-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly dark = signal<boolean>(localStorage.getItem(STORAGE_KEY) === 'dark');

  constructor() {
    effect(() => {
      const dark = this.dark();
      document.documentElement.classList.toggle('dark', dark);
      localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
    });
  }

  toggle(): void {
    this.dark.update((dark) => !dark);
  }
}
